import styled from "styled";

import { Logo } from "componentsV0/Logo";

/**
 * Logo image for use in navigation drawer.
 */
export const DrawerLogo = styled(Logo)`
  > svg {
    width: 44.45px !important;
  }
`;
